<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">アンケート</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">{{ title }}</h3>
    </div>

    <div class="page-block__inner">
      <survey-confirm
        v-if="showConfirmation"
        :questions="questions"
        :answers="answers"
        :others="others"
        @change-clicked="onChangeClicked"
        @send-clicked="onSendClicked">
      </survey-confirm>
      <div
        v-else
        class="profile-info">
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="pcmb20 spmb20"
          v-html="explain"></p>
        <!-- eslint-enable -->
        <form
          class="questionnaire_form"
          :class="{ 'form--error': errors }"
          @submit.prevent="submitForm">
          <div class="form-wrap form-wrap--profile u-no-margin-top">
            <div
              v-for="(item, i) in questions"
              :key="'question' + i"
              :class="{ off: item.disabled }"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="">{{ `Q${i+1}` }} {{ item.title }}</label>
              </div>
              <div class="form-item">
                <!-- select -->
                <div
                  v-if="item.type==='select'"
                  :class="['form-item-inline',item.add_class]">
                  <div
                    class="c-select_wrap">
                    <select
                      v-model="answers[i]"
                      class="form-control c-select">
                      <option
                        value=""
                        disabled
                        selected
                        style="display:none;">
                        選択してください
                      </option>
                      <option
                        v-for="(qitem, n) in item.values"
                        :key="'q'+i+'_'+n"
                        :value="qitem.text">
                        {{ qitem.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- radio -->
                <div
                  v-if="item.type==='radio'"
                  class="form-item-inline form-item-inline_multiple_lines">
                  <div
                    v-for="(qitem, n) in item.values"
                    :key="'q'+i+'_'+n"
                    class="radio">
                    <label>
                      <input
                        v-model="answers[i]"
                        :value="qitem.value"
                        :disabled="item.disabled"
                        type="radio"
                        v-on="item.events">
                      <div class="option-input"></div> {{ qitem.text }}
                    </label>
                  </div>
                </div>
                <!-- checkbox -->
                <div
                  v-if="item.type==='checkbox'"
                  class="form-item-inline form-item-inline_multiple_lines">
                  <div
                    v-for="(qitem, n) in item.values"
                    :key="'q'+i+'_'+n"
                    class="checkbox">
                    <label>
                      <input
                        v-model="answers[i]"
                        :value="qitem.value"
                        :disabled="item.disabled"
                        type="checkbox"
                        v-on="item.events">
                      <div class="option-input"></div> {{ qitem.text }}
                    </label>
                  </div>
                </div>
                <input
                  v-if="item.type==='text'"
                  v-model="answers[i]"
                  class="form-control"
                  type="text"
                  placeholder="">
                <!-- textarea -->
                <textarea
                  v-if="item.type==='textarea'"
                  v-model="answers[i]"
                  class="c-textarea"></textarea>
                <!-- その他 -->
                <div
                  v-if="item.other"
                  class="form-item_textarea">
                  <div class="form-text_textarea_text01" >
                    {{ item.other_title?item.other_title:'その他' }}
                  </div>
                  <div class="form-text_textarea">
                    <input
                      v-model="others[i]"
                      :disabled="item.disabled"
                      class="form-control"
                      type="text"
                      placeholder="">
                  </div>
                </div>
                <p
                  v-if="errors['answers.'+i]"
                  class="error-text">
                  {{ errors['answers.'+i][0] }}
                </p>
                <p
                  v-if="errors['others.'+i]"
                  class="error-text">
                  {{ errors['others.'+i][0] }}
                </p>
              </div>
            </div>
          </div>

          <div class="consent-checkbox-area">
            <div class="checkbox">
              <label>
                <input
                  v-model="confirmed"
                  type="checkbox">
                <div class="option-input"></div>
                <router-link
                  link
                  :to="{ name: 'privacy' }"
                  class="c-text-link"
                  target="_blank">
                  個人情報保護方針
                </router-link>
                に同意して送信する
              </label>
            </div>
          </div>
          <div class="c-btn-wrap">
            <a
              class="c-btn"
              :class="{ 'c-btn--off' : !enableConfirmBtn }"
              @click.prevent="validate">
              内容を確認
              <span class="c-btn__icon-arrow">
              </span>
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SurveyConfirm from './Confirm'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Survey',
  components: { HeaderBar, SurveyConfirm },
  data() {
    return {
      surveyId: 0,
      confirmed: false,
      campaignAccept: false,
      showConfirmation: false,
      title: '',
      explain: '',
      errors: {
        answers: [],
      },
      questions: [],
      answers: [],
      others: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    enableConfirmBtn() {
      if (this.confirmed) {
        return true
      }
      return false
    },
  },
  async mounted() {
    const { data } = await window.axios.get(`/api/client/survey/${this.$route.params.keyword}`)
    if (data.status === false) {
      this.$router.push({ name: 'index' })
    }
    this.surveyId = data.id
    this.questions = data.form_data
    this.title = data.title
    this.explain = data.explain
    for (let i = 0; i < this.questions.length; i += 1) {
      if (this.questions[i].type === 'checkbox') {
        this.answers[i] = []
      } else {
        this.answers[i] = ''
      }
      this.others[i] = ''
      // この部分はアンケートに依存してしまうのでなんとかしたい
      if (i === 22) {
        this.questions[i].events = {
          change: () => {
            if (this.answers[22] === 'ある') {
              this.questions[23].disabled = false
              this.questions[24].disabled = false
            } else {
              this.questions[23].disabled = true
              this.answers[23] = ''
              this.others[23] = ''
              this.questions[24].disabled = true
              this.answers[24] = ''
            }
          },
        }
      } else if (i === 26) {
        this.questions[i].events = {
          change: () => {
            if (this.answers[26] === 'ある') {
              this.questions[27].disabled = false
            } else {
              this.questions[27].disabled = true
              this.answers[27] = ''
              this.questions[28].disabled = true
              this.answers[28] = ''
            }
          },
        }
      } else if (i === 27) {
        this.questions[i].events = {
          change: () => {
            if (this.answers[27] === '少しわかりづらい' || this.answers[27] === 'とてもわかりづらい') {
              this.questions[28].disabled = false
            } else {
              this.questions[28].disabled = true
              this.answers[28] = ''
            }
          },
        }
      } else if (i === 33) {
        this.questions[i].events = {
          change: () => {
            if (this.answers[33] === '条件次第では継続する'
                || this.answers[33] === 'あまり使わないと思う'
                || this.answers[33] === 'もう使わないと思う') {
              this.questions[34].disabled = false
            } else {
              this.questions[34].disabled = true
              this.answers[34] = ''
            }
          },
        }
      }
    }
  },
  methods: {
    onChangeClicked() {
      window.scrollTo(0, 0)
      this.showConfirmation = false
    },
    async onSendClicked() {
      const params = {
        answers: this.answers,
        others: this.others,
        confirmed: true,
      }
      await window.axios.post(`/api/client/survey/${this.surveyId}/answer`, params)
      this.$router.push({ name: 'survey-complete', params: { title: this.title } })
    },
    async validate() {
      try {
        const params = {
          answers: this.answers,
          others: this.others,
        }
        await window.axios.post(`/api/client/survey/${this.surveyId}/answer`, params)
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        window.scrollTo(0, 0)
        this.showConfirmation = response.status === 422
          && Object.keys(errors).length === 1
          && Object.prototype.hasOwnProperty.call(errors, 'confirmed')
      }
    },
  },
}
</script>

<style scoped>
.mb15{
  margin-bottom:15px;
}
.form-text_textarea_text01{
  width:100%;
}
</style>
